import React, {Component} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class TradeMarkItem extends Component {
    render() {
        const {data} = this.props;
        const {wordMark, type, status, regNumber, serialNumber} = data;

        const Status = <span
            className={classNames("badge", status === "LIVE" ? "badge-success" : "badge-danger")}>{status}</span>;

        const Serial = <a target="_blank"
                          href={`http://tsdr.uspto.gov/#caseNumber=${serialNumber}&caseType=SERIAL_NO&searchType=statusSearch`}>{serialNumber}</a>

        return (
            <tr className="TradeMarkItem">
                <td className="Word">{wordMark}</td>
                <td className="Serial">{Serial}</td>
                <td className="Register">{regNumber}</td>
                <td className="Type">{type}</td>
                <td className="Status">{Status}</td>
            </tr>
        );
    }
}

TradeMarkItem.propTypes = {
    data: PropTypes.object.isRequired
};

export default TradeMarkItem;


// WEBPACK FOOTER //
// ./src/app/home/TradeMarkItem.js